import { useMemo } from "react";
import { Version, VersionReference } from "../../types/version";
import { extractReferenceKey } from "../../components/forms/fields/basic/EntitySelectionField";
import { SystemLanguages } from "../../shared/enums/shared-enums";

const useVersionRefLogic = (language?: string | null) => {
  const systemLanguageType = useMemo<Version["system_language_type"]>(() => {
    if (
      !Object.values(SystemLanguages).includes(language as SystemLanguages) ||
      (language !== SystemLanguages.tibetan &&
        language !== SystemLanguages.indic)
    ) {
      return SystemLanguages.tibetan;
    }
    return language as Version["system_language_type"];
  }, [language]);

  const defaultVersionRef = useMemo<VersionReference>(() => {
    return {
      version_exist: false,
      version_notes: "",
      version: null,
      version_id: null,
    };
  }, []);

  const getUpdatedVersionReference = (data: VersionReference | undefined) =>
    data
      ? {
          version_exist: data.version_exist || false,
          version_id: data.version_exist
            ? extractReferenceKey(data.version)
            : null,
          version_notes: data.version_exist ? "" : data.version_notes,
        }
      : defaultVersionRef;

  return {
    systemLanguageType,
    defaultVersionRef,
    getUpdatedVersionReference,
  };
};

export default useVersionRefLogic;
